<template>
    <div>
        <div>
            <div class="d-flex flex-column question mb-2">
                <div class="text-muted mr-1 mb-1">Question:</div>
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="d-flex flex-column suggest-answer">
            <div class="text-muted mr-1 mb-1">Suggested Answer:</div>
            <div v-html="question.content.suggested_answer" class="v-html flex-grow-1 text-success"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    methods: {}
}
</script>
